import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { volumes } from '../data/volumes';
export function Volumes() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-24" data-id="element-377" data-mp="185gd67h8c4pq">
      <div className="mx-auto max-w-4xl" data-id="element-378" data-mp="1c4yz96kselu5">
        <SectionHeading eyebrow="What’s Inside Perio Blueprint™?" title="6 Premium Volumes to Help You Organize the Major Areas of Periodontology" intro="Each volume focuses on a different part of your periodontal knowledge, creating one integrated visual reference system." data-id="element-379" data-mp="1c60cnhp9zkf1" />

        <div className="mt-12 space-y-6" data-id="element-380" data-mp="1qwh8mlj55i4j">
          {volumes.map(v => <article key={v.label} className="overflow-hidden rounded-3xl bg-white shadow-[0_1px_0_rgba(11,27,51,0.06)] ring-1 ring-ink/5" data-id="element-381" data-mp="1vrwk56tof1xs">
              <div className="h-2" style={{
            backgroundColor: v.color
          }} aria-hidden="true" data-id="element-382" data-mp="keaz9xuunmi2" />
              <div className="p-6 sm:p-10" data-id="element-383" data-mp="kby9wzmri9uz">
                <span className="inline-block rounded-md px-3 py-1 text-xs font-black uppercase tracking-widest text-white" style={{
              backgroundColor: v.color
            }} data-id="element-384" data-mp="3o97x2fhj4cps">
                  {v.label}
                </span>
                <h3 className="mt-4 font-serif text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-385" data-mp="3t7j9mxz7l1bp">{v.title}</h3>
                <p className="mt-2 text-lg font-bold leading-snug" style={{
              color: v.color
            }} data-id="element-386" data-mp="b0v63cjt4m85">
                  {v.subtitle}
                </p>
                <p className="mt-4 text-[16px] leading-relaxed text-ink/80 sm:text-[17px]" data-id="element-387" data-mp="60h7el43ioms">{v.intro}</p>

                <p className="mt-6 text-xs font-black uppercase tracking-widest text-muted" data-id="element-388" data-mp="ktiy7tzue20j">Inside, you’ll find</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-389" data-mp="ts4fzmxhpd09">
                  {v.inside.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-390" data-mp="pr2nrq1zq17s">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                  color: v.color
                }} strokeWidth={3} aria-hidden="true" data-id="element-391" data-mp="wu98ilgmgtjb" />
                      <span data-id="element-392" data-mp="11tlvr7beo2mf">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl bg-sand p-4" data-id="element-393" data-mp="16qcb1sfdyu6s">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-394" data-mp="1bjoxbvwleowd" />
                  <p className="text-[15px] leading-relaxed text-ink" data-id="element-395" data-mp="1fl0gpjovidw4">
                    <strong data-id="element-396" data-mp="1kj1vhsf9nr1s">The goal:</strong> {v.goal}
                  </p>
                </div>
                {v.note && <p className="mt-4 text-xs italic leading-relaxed text-muted" data-id="element-397" data-mp="1phvbpslxtw5n">{v.note}</p>}
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-398" data-mp="1ugq1jeibokz9">
          <CTAButton label="I Want All 6 Premium Volumes" data-id="element-399" data-mp="3ra1boldi5540" />
        </div>
      </div>
    </section>;
}